/**
 * Icon Utilities
 *
 * Helper functions for rendering Lucide icons from string names
 */

import React from 'react';
import {
  Database,
  Layers,
  Link,
  ClipboardList,
  CheckSquare,
  BarChart2,
  Plus,
  Settings,
  FileText,
  AlertTriangle,
  Folder,
  MessageSquare,
  Lightbulb,
  Edit3,
  Search,
  Save,
  Info,
  PartyPopper,
  Upload,
  Check,
  X,
  AlertCircle,
  CheckCircle
} from 'lucide-react';

// Map of icon names to Lucide components
const iconMap = {
  Database,
  Layers,
  Link,
  ClipboardList,
  CheckSquare,
  BarChart2,
  Plus,
  Settings,
  FileText,
  AlertTriangle,
  Folder,
  MessageSquare,
  Lightbulb,
  Edit3,
  Search,
  Save,
  Info,
  PartyPopper,
  Upload,
  Check,
  X,
  AlertCircle,
  CheckCircle
};

/**
 * Get a Lucide icon component by name
 * @param {string} iconName - The name of the icon (e.g., 'Database', 'Link')
 * @param {object} props - Props to pass to the icon component (e.g., size, className)
 * @returns {React.ReactElement|null} The icon component or null if not found
 */
export const getIcon = (iconName, props = {}) => {
  const IconComponent = iconMap[iconName];
  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in iconMap`);
    return null;
  }
  return <IconComponent {...props} />;
};

/**
 * Connection icon component that renders the appropriate Lucide icon
 * @param {string} iconName - The icon name from connectionTypes config
 * @param {number} size - Icon size (default: 16)
 * @param {string} className - Additional CSS classes
 */
export const ConnectionIcon = ({ iconName, size = 16, className = '' }) => {
  return getIcon(iconName, { size, className }) || <Database size={size} className={className} />;
};

const iconUtils = { getIcon, ConnectionIcon };

export default iconUtils;
